/* assets/msf-wrapper.js */
(function () {
  // /pages/mimigoto-project（末尾スラッシュも許容）
  if (!location.pathname.startsWith('/pages/mimigoto-project')) return;

  const mount = document.getElementById('msfMount');
  if (!mount) return;

  const params = new URLSearchParams(location.search);
  const id = params.get('id');

  // ✅ 今は一覧が未完成なので、id無しは「案内」にしておく
  if (!id) {
    mount.innerHTML =
      '<div style="padding:16px;border:1px solid #fecaca;background:#fff1f2;border-radius:12px;color:#9f1239;">プロジェクトIDが指定されていません。例：?id=10</div>';
    return;
  }

  // ✅ 公開運用（preview=1 を付けない）
  const url = `/apps/mimigoto/support/${encodeURIComponent(id)}/`;

  function parseYen(text) {
    const digits = String(text || '').replace(/[^\d]/g, '');
    return digits ? Number(digits) : NaN;
  }

  function parseNum(text) {
    const n = parseInt(String(text || '').replace(/[^\d]/g, ''), 10);
    return Number.isFinite(n) ? n : NaN;
  }

  // ✅ 2円以上なら全部、1円/空ならスケジュールだけ
  function applyRules(root) {
    // ① ラベル置換
    const totalTitle = root.querySelector('.msf_current_price_title');
    if (totalTitle) totalTitle.textContent = '現在の総額';

    const supporterTitle = root.querySelector('.msf_supporter_title');
    if (supporterTitle) supporterTitle.textContent = 'パートナー';

    // 「リターン」→「お返しを選ぶ」
    const returnsTitle = root.querySelector('.msf_returns_title');
    if (returnsTitle) returnsTitle.textContent = 'お返しを選ぶ';

    // 「このリターンを購入」→「このお返しを選ぶ」
    root.querySelectorAll('.msf_return_cta a').forEach((a) => {
      if (a.textContent.trim() === 'このリターンを購入') a.textContent = 'このお返しを選ぶ';
    });

    // ✅ 価格の "JPY" を削除（ここに入れる）
root.querySelectorAll('.msf_return_price').forEach(el => {
  el.textContent = el.textContent.replace(/\s*JPY\s*$/i, '').trim();
});

    // ② 2円以上なら全部、1円/空ならスケジュールだけ
    const targetVal = root.querySelector('.msf_target_value');
    const yen = targetVal ? parseYen(targetVal.textContent) : NaN;
    const showAll = Number.isFinite(yen) && yen >= 2;

    const schedule = root.querySelector('.msf_container_schedule');
    if (schedule) schedule.style.marginTop = showAll ? '12px' : '0';

    const priceBox = root.querySelector('.msf_container_price');
    if (priceBox) priceBox.style.display = showAll ? '' : 'none';

    const supporterBox = root.querySelector('.msf_container_supporter');
    if (supporterBox) supporterBox.style.display = showAll ? '' : 'none';

    const targetBox = root.querySelector('.msf_container_target');
    if (targetBox) targetBox.style.display = showAll ? '' : 'none';

    const right = root.querySelector('.msf_container_top_right');
    if (right) {
      right.style.justifyContent = 'flex-start';
      right.style.padding = '12px';
      if (!showAll) right.style.gap = '0';
    }

    // ③ お返し：残り表示 / SOLD OUT（残り0） + 見た目強化
    root.querySelectorAll('.msf_return_item').forEach((item) => {
      const titleEl = item.querySelector('.msf_return_title');
      const invEl = item.querySelector('.msf_return_inventory');
      const ctaEl = item.querySelector('.msf_return_cta');
      const imgWrap = item.querySelector('.msf_return_image');

      if (!invEl) return;

      const title = (titleEl?.textContent || '').trim();
      const stock = parseNum(invEl.textContent);
      const isLimited = title.includes('限定');

      // バッジ重複防止
      const existingBadge = item.querySelector('.msf_soldout_badge');
      if (existingBadge) existingBadge.remove();

      const isSoldOut = Number.isFinite(stock) && stock <= 0;

      if (isSoldOut) {
        // 表記：残り：0個
        invEl.style.display = '';
        invEl.textContent = '残り：0個';
        invEl.style.fontWeight = '800';

        // 購入ボタンを消す
        if (ctaEl) ctaEl.style.display = 'none';

        // 画像左上に SOLD OUT バッジ（赤）
        if (imgWrap) {
          imgWrap.style.position = 'relative';

          const badge = document.createElement('div');
          badge.className = 'msf_soldout_badge';
          badge.textContent = 'SOLD OUT';
          badge.style.position = 'absolute';
          badge.style.top = '10px';
          badge.style.left = '10px';
          badge.style.padding = '6px 10px';
          badge.style.borderRadius = '999px';
          badge.style.fontSize = '12px';
          badge.style.fontWeight = '900';
          badge.style.letterSpacing = '0.08em';
          badge.style.background = '#e11d48';
          badge.style.color = '#fff';
          badge.style.boxShadow = '0 8px 18px rgba(2,6,23,.25)';
          badge.style.zIndex = '2';

          imgWrap.appendChild(badge);
        }
        return;
      }

      // SOLD OUTじゃない場合は元に戻す（再描画対策）
      item.style.opacity = '';
      item.style.filter = '';
      if (ctaEl) ctaEl.style.display = '';

      // 「限定」を含む場合だけ表示：残り：xx個（太字）
      if (isLimited && Number.isFinite(stock)) {
        invEl.style.display = '';
        invEl.textContent = `残り：${stock}個`;
        invEl.style.fontWeight = '800';
      } else {
        // 限定がなければ非表示
        invEl.style.display = 'none';
      }
    });
  }

  // ✅ mimigoto-projectページだけ、ストアのヘッダーを丸ごと非表示
  if (!document.getElementById('mimigotoHideStoreHeader')) {
    const s = document.createElement('style');
    s.id = 'mimigotoHideStoreHeader';
    s.textContent = `
      header.header,
      header.site-header,
      .header-wrapper,
      .site-header,
      #shopify-section-header,
      .shopify-section--header {
        display: none !important;
      }
      body { padding-top: 0 !important; }
    `;
    document.head.appendChild(s);
  }

  async function load() {
    mount.innerHTML = `<div style="padding:16px;color:#64748b;">読み込み中…</div>`;

    let html;
    try {
      const res = await fetch(url, { credentials: 'same-origin' });
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      html = await res.text();
    } catch (e) {
      mount.innerHTML = `<div style="padding:16px;color:#b91c1c;">読み込み失敗：${String(e.message || e)}</div>`;
      return;
    }

    const doc = new DOMParser().parseFromString(html, 'text/html');

    // MyStoreFunding側の<style>を注入（見た目維持）
    const style = doc.querySelector('style');
    if (style && !document.getElementById('msfInjectedStyle')) {
      const s = document.createElement('style');
      s.id = 'msfInjectedStyle';
      s.textContent = style.textContent;
      document.head.appendChild(s);
    }

    // Material Icons が無ければ追加（アイコン表示復活）
    if (!document.querySelector('link[href*="fonts.googleapis.com/icon?family=Material+Icons"]')) {
      const l = document.createElement('link');
      l.rel = 'stylesheet';
      l.href = 'https://fonts.googleapis.com/icon?family=Material+Icons';
      document.head.appendChild(l);
    }

    // 本体を差し込み
    const header = doc.querySelector('.msf_header');
    const container = doc.querySelector('.msf_container');

    mount.innerHTML = '';
    if (header) mount.appendChild(header.cloneNode(true));
    if (container) mount.appendChild(container.cloneNode(true));

    // ✅ .msf_header の背景色を #e1d4e4 に上書き（1回だけ）＋下線は完全になし
    if (!document.getElementById('msfHeaderBgOverride')) {
      const s = document.createElement('style');
      s.id = 'msfHeaderBgOverride';
      s.textContent = `
        .msf_header {
          background-color: #e1d4e4 !important;
          border-bottom: none !important;
        }
      `;
      document.head.appendChild(s);
    }

    // ✅ MyStoreFundingの上下余白を詰める（1回だけ）
    if (!document.getElementById('msfSpacingOverride')) {
      const s = document.createElement('style');
      s.id = 'msfSpacingOverride';
      s.textContent = `
        .msf_container { margin: 0 auto !important; padding-top: 12px !important; padding-bottom: 12px !important; }
        .msf_title { margin-top: 12px !important; }
        .msf_container_body { margin-top: 12px !important; }
      `;
      document.head.appendChild(s);
    }

    // ✅ お返しカード：余白 + フォントサイズ調整（安全に見た目だけ変更）
if (!document.getElementById('msfReturnTypographyV2')) {
  const s = document.createElement('style');
  s.id = 'msfReturnTypographyV2';
  s.textContent = `
    /* タイトル */
    .msf_return_title{
      font-size:18px !important;
      font-weight:700 !important;
      line-height:1.4 !important;
    }

    /* 説明文：価格/在庫段との間に「1行分」空白 */
    .msf_return_description{
      font-size:14px !important;
      line-height:1.6 !important;
      margin-bottom:16px !important; /* ← 1行分の空白（必要なら 18〜20 に調整OK） */
    }

    /* 価格（JPY削除後の表示もここに乗る） */
    .msf_return_price{
      font-size:16px !important;
      font-weight:600 !important;
      line-height:1.4 !important;
    }

    /* 在庫/残り/SOLD OUT（ここで16に揃える） */
    .msf_return_inventory{
      font-size:16px !important;
      font-weight:600 !important;
      line-height:1.4 !important;
    }
  `;
  document.head.appendChild(s);
}

    // ✅ 数量表記（残り：xx個 / 残り：0個）を右寄せ（displayは触らない）
if (!document.getElementById('msfInventoryRightAlign')) {
  const s = document.createElement('style');
  s.id = 'msfInventoryRightAlign';
  s.textContent = `
    .msf_return_meta{ width:100% !important; }

    /* 右寄せ。display は触らない（JSの display:none を殺さない） */
    .msf_return_inventory{
      margin-left:auto !important;
      text-align:right !important;
    }
  `;
  document.head.appendChild(s);
}

    applyRules(mount);
  }

  load();
})();